import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M17.519 8.823c.768 1.184-.071 3.087-1.11 3.55-1.563.697-1.598 2.47-.868 3.627-5.41-2.87-3.034-10.372 2.667-9.986-1.201.612-1.375 1.753-.69 2.81m-2.592 1.455.145.722.399-.62.737.086-.472-.568.31-.668-.69.27-.545-.5.045.734-.648.36zm4.52 5.836c.76.844 2.83 1.054 3.718-.042.793-.98 1.932-1.166 2.884-.213-1.394-5.542-9.264-5.483-10.32.55.874-1.052 2.571-1.567 3.717-.295m-1.431 7.567c-1.317-.506-1.757-2.539-1.189-3.523.855-1.484-.159-2.938-1.43-3.445 6.064-.86 8.552 6.607 3.712 9.646.613-1.2.083-2.226-1.093-2.678m-5.844-4.765c-1.113-.236-2.91.811-2.984 2.22-.066 1.258-.878 2.079-2.209 1.867 4.385 3.664 10.718-1.01 8.027-6.51-.09 1.364-1.16 2.779-2.835 2.423M8.88 11.953c1.363-.365 2.914 1.022 3.034 2.152.18 1.703 1.855 2.283 3.18 1.947-4.4 4.259-10.802-.32-8.672-5.622.21 1.331 1.241 1.85 2.458 1.523m11.459 2.464.642-.36-.048-.742.543.506.684-.27-.307.673.47.573-.731-.088-.394.624-.146-.728zm-1.081 6.564-.542-.499.042.737-.647.363.715.182.142.723.4-.624.735.084-.468-.567.313-.672zm-6.811-.168-.308.67.474.571-.736-.09-.395.62-.147-.724-.718-.188.644-.358-.047-.736.545.503zm-2.984-5.946.731.086-.467-.571.31-.675-.685.273-.54-.501.043.74-.643.364.712.184.142.728z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagHkg = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagHkg_default = SvgFlagHkg;

export { FlagHkg_default as default };
